<div class="maincontainer">
  <div class="formContainer">
    <div [formGroup]="form" class="form">
      <label>
        <input type="email" formControlName="email" placeholder="{{ 'admin.invite.email.placeholder' | translate }}" />
      </label>
      <label>
        <input type="text" formControlName="firstName" placeholder="{{ 'admin.invite.firstname.placeholder' | translate }}" />
      </label>
      <label>
        <input type="text" formControlName="lastName" placeholder="{{ 'admin.invite.lastname.placeholder' | translate }}" />
      </label>
      <button (click)="inviteUser()" [disabled]="isSending">{{ 'admin.invite.button.send' | translate }}</button>
    </div>
    <div class="info">
      <div class="infoheading">{{ 'admin.invite.headline.instruction' | translate }}</div>
      <ol>
        <li>{{ 'admin.invite.description1' | translate }}</li>
        <li>{{ 'admin.invite.description2' | translate }}</li>
        <li>{{ 'admin.invite.description3' | translate }}</li>
        <li>{{ 'admin.invite.description4' | translate }}</li>
      </ol>
    </div>
  </div>
</div>
